import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';
import { WizardUtils } from '../../../../../utils/WizardUtils';

export const CriteriaFormulaPreview = ({ conditionTree }) => {
  const formulaString = useMemo(() => WizardUtils.createTriggerConditionStringFromTree(conditionTree), [conditionTree]);

  return (
    <TextField
      disabled
      fullWidth
      value={formulaString}
      minRows={5}
      multiline
      data-cy="criteria-formula-preview-textfield"
    />
  );
};

CriteriaFormulaPreview.propTypes = {
  conditionTree: PropTypes.object,
};

CriteriaFormulaPreview.defaultProps = {
  conditionTree: {},
};
